namespace GeniuzPOS.Inventory {
    export namespace IcStockSetAssembleDtService {
        export const baseUrl = 'Inventory/IcStockSetAssembleDt';

        export declare function Retrieve(request: Serenity.RetrieveRequest, onSuccess?: (response: Serenity.RetrieveResponse<IcStockSetAssembleDtRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function List(request: Serenity.ListRequest, onSuccess?: (response: Serenity.ListResponse<IcStockSetAssembleDtRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            Retrieve = "Inventory/IcStockSetAssembleDt/Retrieve",
            List = "Inventory/IcStockSetAssembleDt/List"
        }

        [
            'Retrieve', 
            'List'
        ].forEach(x => {
            (<any>IcStockSetAssembleDtService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
